import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {
  LoginResponsePayload,
  SendCodeResponsePayload,
  SendCodeWithCheckPhoneResponsePayload,
} from '../../../shared/models/api';

export interface LoginState {
  loginResponse: LoginResponsePayload | null;
  login: string | null;
  sendCodeResponse: SendCodeResponsePayload | null;
  sendCodeWithCheckPhoneResponse: SendCodeWithCheckPhoneResponsePayload | null;
}

const initialState: LoginState = {
  loginResponse: null,
  login: null,
  sendCodeResponse: null,
  sendCodeWithCheckPhoneResponse: null,
};

export const loginSlice = createSlice<LoginState, SliceCaseReducers<LoginState>>({
  name: '@@eskmo/login',
  initialState,
  reducers: {
    setLoginResponse: (state, action: PayloadAction<LoginResponsePayload>) => {
      state.loginResponse = action.payload;
    },
    setLogin: (state, action: PayloadAction<string>) => {
      state.login = action.payload;
    },
    setSendCodeResponse: (state, action: PayloadAction<SendCodeResponsePayload>) => {
      state.sendCodeResponse = action.payload;
    },
    setCodeWithCheckPhoneResponse: (state, action: PayloadAction<SendCodeWithCheckPhoneResponsePayload>) => {
      state.sendCodeWithCheckPhoneResponse = action.payload;
    },
    reset: () => {
      return initialState;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const login = loginSlice.reducer;
